import { Grid } from "@mui/material";
import { lazy } from "react";
import SuspenseComponent from "../../components/SuspenseComponent";
import { mainBg } from "../../config/constants";

const RegisterPerson = lazy(() => import("./RegisterPerson"));

const Register = () => {
  return (
    <Grid
      container
      sx={{
        height: 1,
        backgroundImage: `url(${mainBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100dvh",
      }}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      alignContent="center"
    >
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        alignContent="start"
        container
        justifyContent="start"
        textAlign="start"
      >
        <Grid
          item
          justifyContent="start"
          alignSelf="start"
          justifySelf="start"
          textAlign="start"
          sx={{ display: { xs: "none", sm: "none", md: "block" }, ml: 10 }}
        >
          <img
            loading="lazy"
            src={"/images/layout/logo.png"}
            height={100}
            alt=""
          />
        </Grid>
      </Grid>
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        sx={{ px: { md: 5, xs: 1, sm: 1 }, height: 1 }}
        alignContent="center"
        container
      >
        <Grid
          item
          sm={12}
          xs={12}
          // sx={{ height: { lg: "65%", md: "80%", sm: "80%" } }}
        >
          <SuspenseComponent>
            <RegisterPerson />
          </SuspenseComponent>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Register;
